import React, { useState, useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import CommonPopup from './CommonPopup';
import { playGameApi } from '../../services/authApi'
import { getPublicIp } from '../../services/pulicApi';
import { t, getLang } from "../../lang";
export default function GameDialog({ isOpen, onClose, gameData }) {
  const [gameInfo, setGameInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [popup, setPopup] = useState(null);
  const [lang, setLangState] = useState(getLang());

  useEffect(() => {
    const handler = () => setLangState(getLang());
    window.addEventListener("langChanged", handler);
    return () => window.removeEventListener("langChanged", handler);
  }, []);

  useEffect(() => {
    if (isOpen) {
        window.isGameOpen = true;
    } else {
        window.isGameOpen = false;
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen && gameData) {
      fetchGameInfo();
      // Disable body scrolling when dialog is open
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable body scrolling when dialog is closed
      document.body.style.overflow = '';
    }
    
    // Cleanup: re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen, gameData]);

  const fetchGameInfo = async () => {
    setIsLoading(true);
    try {
      // const token = localStorage.getItem('authToken');
      // const tokenType = localStorage.getItem('tokenType');
      
      // Get gameCode and vendorCode from gameData
      const gameCode = gameData?.gameCode || '';
      const vendorCode = gameData?.vendorCode || '';
      
      // Make POST request to playgame API
      const response = await playGameApi(gameCode, vendorCode);
      if(!response) return;
      
      // Extract data from API response
      const apiData = response.data?.data || response.data || {};
      
      // Generate event-id
      const eventId = apiData.eventId || generateEventId();
      
      // Get client IP from API response or fallback
      const clientIp = apiData.clientIp || await getClientIp();
      
      // Get current time
      const currentTime = apiData.time || new Date().toLocaleString('en-US', { 
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }) + ' PST';

      // Get URL and key from API response
      const gameUrl = apiData.url || apiData.gameUrl;
      // No launch URL (e.g. API error): show no game instead of a broken fallback URL
      if (!gameUrl) {
        setGameInfo(null);
        return;
      }
      const key = apiData.key || apiData.token || '';

      setGameInfo({
        url: gameUrl,
        key: key,
        eventId: eventId,
        clientIp: clientIp,
        time: currentTime
      });
    } catch (error) {
      console.error("Error fetching game info:", error);
      setGameInfo(null);
    } finally {
      setIsLoading(false);
    }
  };

  const generateEventId = () => {
    return Array.from({ length: 32 }, () => 
      Math.floor(Math.random() * 16).toString(16)
    ).join('');
  };

  const getClientIp = async () => {
    try {
      // Try to get IP from a service or use a default
      const response = await getPublicIp();
      return response.data.ip;
    } catch (error) {
      // Fallback to a default IP or get from your backend
      return '155.254.19.131';
    }
  };

  useEffect(() => {
    const depositHandler = () => {
      if (!window.isGameOpen) return;  

      setPopup({
        title: "",
        message: "The deposit has been completed"
      });
    };

    const withdrawalHandler = () => {
      if (!window.isGameOpen) return; 

      setPopup({
        title: "",
        message: "The withdrawal has been completed"
      });
    };

     const betLimitHandler = () => {
      if (!window.isGameOpen) return; 

      setPopup({
        title: "",
        message: "ベット制限にかかっています。"
      });
    };

    const userGameClone = async (e) => {

      if (!window.isGameOpen) return;

      const gameCode = e.detail?.game_code;
      const gameCodeClone = e.detail?.game_code_clone;

      const currentGameCode = gameData?.gameCode;
      if (
        currentGameCode === gameCode ||
        currentGameCode === gameCodeClone
      ) {
        // fetchGameInfo toggles isLoading, which remounts the iframe with the new URL
        await fetchGameInfo();
      }

      return;
    };

    window.addEventListener("DepositCompleted", depositHandler);
    window.addEventListener("withdrawalCompleted", withdrawalHandler);
    window.addEventListener("BetLimitExceeded", betLimitHandler);
    window.addEventListener("UseGameClone", userGameClone);

    return () => {
      window.removeEventListener("DepositCompleted", depositHandler);
      window.removeEventListener("withdrawalCompleted", withdrawalHandler);
      window.removeEventListener("BetLimitExceeded", betLimitHandler);
      window.removeEventListener("UseGameClone", userGameClone);
    };
  }, [gameData]);


  const handleClosePopup = () => {
    setPopup(null);

    // Reload the game to refresh the balance shown in it, with a fresh launch URL
    // instead of the old one, which may have expired
    fetchGameInfo();
  };

  if (!isOpen) return null;

  // Get game title from gameData
  const gameTitle = gameData?.gameTitle || gameData?.title || 'Game';

  
  return (
    <div className="game-dialog-overlay"  onClick={() => {
      if (!popup) onClose();  
    }}>
      <div className="game-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="game-dialog-back-btn" onClick={onClose}>
            <IoIosArrowBack />
        </div>
        
        <div className="game-dialog-header">
          <h2 className="game-dialog-title">{gameTitle}</h2>
        </div>
        
        <div className="game-dialog-content">
          {isLoading ? (
            <div className="game-dialog-loading">
              <div className="loading-spinner"></div>
              <span>{t("common.loading_game")}</span>
            </div>
          ) : (
            <>
              {gameInfo && (
                <iframe 
                  id="gameIframe"
                  src={gameInfo.key ? `${gameInfo.url}${gameInfo.key}` : gameInfo.url} 
                  title={gameTitle} 
                  className="game-dialog-iframe"
                  allowFullScreen
                ></iframe>
              )}
            </>
          )}
        </div>
      </div>
      {popup && (
        <CommonPopup title={popup.title} message={popup.message} onClose={handleClosePopup}/>
      )}
    </div>
  );
}

